import { Controller } from 'stimulus';
import { initTooltips } from 'ez-styles/assets/javascripts/ez-styles/utils/tooltips';

export default class CollectionsPrivacyControlController extends Controller {
  connect() {
    initTooltips();
  }

  tooltipClick = (event) => {
    event.preventDefault();
  }
}
